import React, { useState, useEffect } from "react";
import useStorageState from "@/hooks/useStorageState";
import { createModel } from "hox";
import { ISalesSearch, ISalesDetail, ISalesStatistics } from "./salesTypes"
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/SCMTypes";
import { salesService } from "./salesService";
import { transPgToPagination, formatNum } from "@/utils/utils";
import { convertRes2Blob } from "@/utils/exportFile";
export const useISalesModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<ISalesDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ISalesSearch>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: ISalesStatistics = {
        receivedAmount: 0,
        amountReceived: 0,
    }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [descTotal, setDescTotal] = useState<ISalesStatistics>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<ISalesStatistics>(initDesc);
    const [descRows, setDescRows] = useState<ISalesDetail[]>([]);
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { receivedAmount, amountReceived } = item
            newRowsDescTotal.receivedAmount += +formatNum(receivedAmount)
            newRowsDescTotal.amountReceived += +formatNum(amountReceived)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    const loadData = async (page?: ISearchPage, searchValue: ISalesSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await salesService.saleAmount(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISalesSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //列表导出
    const salesExport = async () => {
        let result = await salesService.export({
            ...searchParam,
            id: selectedRowKeys.join(),
            status:"sale.settle,sale.stock-io",
            pageSize: 0,
            pageNum: 0,

        });
        convertRes2Blob(result)
    }
    return {
        dataSource,
        searchParam,
        initPgCfg,
        pgCfg,
        selectedRowKeys,
        setDataSource,
        setSearchParam,
        setPgCfg,
        loadData,
        updateSearchParam,
        resetSearchParam,
        setSelectedRowKeys,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        salesExport
    }
})